import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";

const LANG_BASE = "vessel-call.port-services.fields";

export const internalOnlySchema = z
  .object({
    files: z.any().optional(),
    internalNotes: z
      .string()
      .max(
        1000,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.internal-notes`),
          max: 1000,
        }),
      )
      .optional(),
  })
  .merge(notificationSchema);

export const externalOnlySchema = z
  .object({
    files: z.any().optional(),
    externalNotes: z
      .string()
      .max(
        1000,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.external-notes`),
          required_error: i18n.t("form-validation.required", {
            label: i18n.t(`${LANG_BASE}.external-notes`),
          }),
          max: 1000,
        }),
      )
      .optional(),
  })
  .merge(notificationSchema);

export const approvedByMDGarbageDisposalSchema = () =>
  internalOnlySchema.merge(externalOnlySchema).merge(notificationSchema);

export type ApprovedByMDGarbageDisposalSchema = z.infer<
  ReturnType<typeof approvedByMDGarbageDisposalSchema>
>;
